<template>
  <NavigationPopOver v-if="items.length > 0" :items="items">
    <template v-slot:reference="{ on }">
      <v-btn dark icon v-on="on">
        <v-icon>apps</v-icon>
      </v-btn>
    </template>
  </NavigationPopOver>
</template>

<script>
import NavigationPopOver from "./NavigationPopOver.vue";
import { mapState } from "vuex";
import { PLATFORMS } from "@/constants/platforms";

export default {
  components: {
    NavigationPopOver
  },

  data() {
    return {
      navItems: [
        {
          name: "home",
          icon: "satellite",
          text: "Dashboard",
          newTab: false,
          platforms: [PLATFORMS.ADMINISTRATION, PLATFORMS.DISTRICT]
        },
        {
          name: "map3d",
          icon: "map",
          text: "3D Map",
          newTab: false,
          platforms: [PLATFORMS.ADMINISTRATION, PLATFORMS.DISTRICT]
        },
        {
          name: "complaints",
          icon: "report_problem",
          text: "Complaints",
          newTab: false,
          platforms: [
            PLATFORMS.ADMINISTRATION,
            PLATFORMS.DISTRICT,
            PLATFORMS.DEPARTMENT
          ]
        },
        {
          name: "departments",
          icon: "home",
          text: "Departments",
          newTab: false,
          platforms: [
            PLATFORMS.ADMINISTRATION,
            PLATFORMS.DEPARTMENT,
            PLATFORMS.DISTRICT
          ]
        },
        {
          name: "utilities",
          icon: "category",
          text: "Categories",
          newTab: false,
          platforms: [PLATFORMS.ADMINISTRATION, PLATFORMS.DISTRICT]
        },
        {
          name: "dist-admins",
          icon: "account_box",
          text: "District Admins",
          newTab: false,
          platforms: [PLATFORMS.ADMINISTRATION]
        },
        // {
        //   name: "vendors",
        //   icon: "engineering",
        //   text: "Vendors",
        //   newTab: false,
        //   // platforms: [PLATFORMS.ADMINISTRATION]
        // },
        {
          name: "staffs",
          icon: "record_voice_over",
          text: "Staffs",
          newTab: false,
          platforms: [PLATFORMS.ADMINISTRATION, PLATFORMS.DEPARTMENT]
        },
        {
          name: "citizens",
          icon: "face",
          text: "Citizens",
          newTab: false,
          platforms: [PLATFORMS.ADMINISTRATION, PLATFORMS.DEPARTMENT]
        },
        // {
        //   name: "service-requests",
        //   icon: "work",
        //   text: "Service Requests",
        //   newTab: false,
        //   // platforms: [PLATFORMS.ADMINISTRATION]
        // }
      ]
    };
  },

  computed: {
    ...mapState("auth", ["currentUser"]),

    items() {
      return this.navItems.filter(item => {
        if (!item.platforms) return true;

        return item.platforms.includes(this.currentUser.platform);
      });
    }
  }
};
</script>

<style lang="css" scoped>
.nav-button {
  position: absolute;
  top: 10px;
  right: 50px;
  z-index: 1001;
  display: flex;
  width: 36px;
  height: 36px;
  padding: 0;
  font-size: 28px;
  line-height: 36px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  cursor: pointer;
  background-color: transparent;
  border: none;
  border-radius: 50%;
  transition: color 0.2s;
}

.nav-button:hover,
.nav-button:focus {
  color: white;
}
</style>
